import Icon from '../components/Icon.vue'

Icon.register({"microphone":{"width":384,"height":512,"paths":[{"d":"M96 256V96C96 43 139 0 192 0S288 43 288 96V256C288 309 245 352 192 352S96 309 96 256zM348 200H324C317.4 200 312 205.4 312 212V254.7C312 320.9 258.9 375.6 192.7 376 126.2 376.4 72 322.4 72 256V212C72 205.4 66.6 200 60 200H36C29.4 200 24 205.4 24 212V256C24 340.5 86.7 410.6 168 422.3V468H100C93.4 468 88 473.4 88 480V500C88 506.6 93.4 512 100 512H284C290.6 512 296 506.6 296 500V480C296 473.4 290.6 468 284 468H216V422.3C297.3 410.6 360 340.5 360 256V212C360 205.4 354.6 200 348 200z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/microphone.js
// module id = null
// module chunks = 